import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { WalletService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import dayjs from "dayjs";
import authService from "@/services/modules/authService";
import makeSecure from "@/components/MakeSecure";

export default {
  name: "account-sidebar",
  components: { makeSecure },
  // props: [],
  mixins: [$thousandMask],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      isButtonHover: false,
      totalMoney: "",
      totalProfit: ""
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      isSidebarOpen: types.account.getters.IS_SIDEBAR_OPEN
      // wallet: types.wallets.getters.GET_WALLETS
    }),

    referralCode() {
      return this.userInfo?.referral_code;
    },

    isVerify() {
      return this.userInfo?.is_verified;
    },

    mobile() {
      return this.userInfo?.mobile;
    },

    isOpen: {
      get() {
        return this.isSidebarOpen;
      },
      set(val) {
        this.setSideBar(val);
      }
    },

    thousandTotalMoney() {
      return this.$thousandMask(this.totalMoney);
    },

    thousandTotalProfit() {
      return this.$thousandMask(this.totalProfit);
    },

    version() {
      const packageJson = require("@/../package.json");
      return packageJson.version;
    },

    year() {
      return dayjs().year();
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.getWalletService();
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setSideBar: types.account.actions.SET_SIDEBAR,
      setAccountTab: types.account.actions.SET_TAB
    }),
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("isDark", this.$vuetify.theme.dark);
    },
    getWalletService() {
      WalletService.getWalletV4().then(res => {
        this.totalMoney = res.data.data.total_portfolio.IRR;
        this.totalProfit = res.data.data.total_profits_or_losses_amounts.IRR;
      });
    },

    closeSidebar() {
      this.setSideBar(false);
    },

    copyCode() {
      this.$toast.success(
        this.$t("accountPage.accountSidebar.referralCard.referralCodeCopied")
      );
    },

    goPersonal() {
      if (this.userVerifyInfo.is_user_verified)
        this.$router.push({
          name: "level"
        });
      else
        this.$router.push({
          name: "personalInformation"
        });

      this.setSideBar(false);
    },

    goBanking() {
      this.$router.push({
        path: "/account/banking"
      });
      this.setSideBar(false);
    },

    goSecurity: function() {
      this.$router.push({
        path: "/account/security"
      });
      this.setSideBar(false);
    },

    signOutFunc() {
      authService.signOut().then(() => {
        localStorage.removeItem("accessToken");
        localStorage.setItem("isAuth", "false");
        this.$cookies.remove(
          "accessToken",
        );
        this.$cookies.remove("accessToken" , null , '.ernyka.com')
        this.$cookies.remove("accessToken" , null , '.excoino.com')
        location.reload();
      });
    }

    // darkMode() {
    //   this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    // }
  }
};
